<template>
    <div class="hello-page-wrapper video-player-wrapper fixgraybgpl">
        <div :class="{'animated zoomOutLeft': videoCompleted}" v-show="!videoSqueeze" class="video-player-background">
            <div class="container-fluid">
                <div class="row">
                    <div class="video-player" @mouseleave="addRightHoverWidthClass ? resetClass(true) : resetClass(false)">
                        <div class="left-video-icons" v-show="!hideLeftVideoIcons"></div>
                        <!-- div v-if="currentVideo" class="reset-video-width" :class="{'enjoy-hover': addEnjoyHoverClass}">
                        <jwplayer id="mainVideoPlayer" :data="currentVideo" :on-complete="onVideoComplete">Loading the player...</jwplayer>
                        </div -->
                        <div v-if="getTrendingNewPlaylistObject" class="reset-video-width" :class="{'enjoy-hover': addEnjoyHoverClass}">
                            <jwplaylist :data = "getTrendingNewPlaylistObject" :on-playlistitem="videoChangedInPlaylist()" ></jwplaylist>
                        </div>
                    </div>
                    <div class="playlistholderdiv" v-if="playlistVideos">
                        <h4>{{playlistVideos.title}}</h4>
                        <p>({{videoIndex}} of {{playlistVideos.userPlaylistVideos.length}})</p>
                        <div>
                            <!-- draggable v-model="playlistVideos.userPlaylistVideos" :options="{disabled: dragFlagDisabled, delay:200, forceFallback: true}" @start="drag=false" @end="drag=false" @update="listUpdated">
                                    <div  v-for="(item, index) in playlistVideos.userPlaylistVideos" :key="index">
                                        <div class="playlistentrydiv" :class="{'playing': item.videoCode === $route.params.videoCode}" @click="playVideo(playlistVideos.playlistId, item.videoCode, playlistVideos.title)">
                                            <img :src="item.thumbnailURL" style="cursor: pointer" @click="playVideo(playlistVideos.playlistId, item.videoCode, playlistVideos.title) "/>
                                            <p style="cursor:pointer;"  @click="playVideo(playlistVideos.playlistId, item.videoCode, playlistVideos.title)">{{item.videoTitle}}</p>
                                        </div>
                                    </div>
                            </draggable -->
                            <!-- draggable v-model="getTrendingNewPlaylistObject" :options="{disabled: dragFlagDisabled, delay:200, forceFallback: true}" @start="drag=false" @end="drag=false" @update="listUpdated" -->
                                    <div v-if="getTrendingNewPlaylistObject && getItemChangeInPlaylist"  v-for="item in getTrendingNewPlaylistObject">
                                        <div class="playlistentrydiv" :class="{'playing': item.videoCode === getItemChangeInPlaylist.item.videoCode}" @click="playVideoInPlylist(item)">
                                            <img :src="item.image" style="cursor: pointer" @click="playVideoInPlylist(item)" :alt="item.title" :title="item.title"/>
                                            <p style="cursor:pointer;"  @click="playVideoInPlylist(item)">{{item.title}}</p>
                                        </div>
                                    </div>
                            <!-- /draggable -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="player-content">
                        <h4>{{currentVideo.title}}</h4>
                        <p>
                            {{currentVideo.Description}}
                        </p>
                        <div class="profile-content" v-if="getExpert">
                            <a :href="'/expert/' + getExpert[0].expertId + '/' + getExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" target="_blank">
                            <img v-bind:src="getExpert[0].small_image" alt="">
                            <h4>{{getExpert && getExpert[0].name}}</h4>
                            <span>{{getExpert && getExpert[0].experties}}</span>
                            </a>
                        </div>
                        <p class="video-text">
                            {{getExpert && getExpert[0].areasofexpertise}}
                        </p>
                        <div class="row">
                            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">
                                <button class="btn btn-danger recently-watched-btn btn-transparent btn-lg"
                                        @click="toggleViewTranscript"
                                        v-bind:style="[viewTranscript ? { color: '#FFFFFF !important', backgroundColor: this.getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', outline: 'none !important'} : { color: getCorpButtonColor + ' !important', backgroundColor: '#FFFFFF !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important', outline: 'none !important'}]">
                                    <span v-show="!viewTranscript">View Transcript</span>
                                    <span v-show="viewTranscript">Hide Transcript</span>
                                </button>
                            </div>
                            <div class="col-xs-12 col-sm-8 col-md-8 col-lg-9">
                                <div class="side-content" v-if="getCurrentVideoTranscript"
                                     v-bind:style="{ 'border-left-color': this.getCorpHeaderColor + ' !important'}">
                                    <div v-show="viewTranscript" class="boxes"
                                         :class="{'animated fadeIn': viewTranscript, 'animated fadeOut': !viewTranscript}"
                                         >
                                        <pre><p v-html="getCurrentVideoTranscript.vtt_file">
                                        </p></pre>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--<div class="profile-content" v-if="getExpert">-->
                            <!--<img v-bind:src="getExpert[0].small_image" alt="">-->
                            <!--<h4>{{getExpert[0].name}}</h4>-->
                            <!--<span>{{getExpert[0].experties}}</span>-->
                        <!--</div>-->
                        <!--<p class="video-text">-->
                            <!--{{getExpert[0].biography}}-->
                        <!--</p>-->
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="recently-watched" style="margin-bottom: 10px;" v-if="showPlaylist">-->
            <!--<div class="container">-->
                <!--<div class="row" v-if="playlistVideos">-->
                    <!--<div class="col-md-12">-->
                        <!--<h2>PLAYLIST</h2>-->
                    <!--</div>-->
                    <!--<div class="col-md-12">-->
                        <!--<div class="content">-->
                            <!--<div class="slider responsive-slick-slider">-->
                                <!--<div v-for="item in playlistVideos.userPlaylistVideos">-->
                                    <!--<div class="slide-player playlistentrydiv" :class="{'playingMobile': item.videoCode === $route.params.videoCode}">-->
                                        <!--<img :src="item.thumbnailURL" style="cursor: pointer" @click="playVideo(playlistVideos.playlistId, item.videoCode) "/>-->
                                        <!--<p class="text-wrap-title">-->
                                            <!--<i class="fa fa-play-circle-o"></i>{{item.videoTitle}}-->
                                        <!--</p>-->
                                        <!--&lt;!&ndash;<hr>&ndash;&gt;-->
                                        <!--&lt;!&ndash;<p class="right-heart-icon">&ndash;&gt;-->
                                        <!--&lt;!&ndash;<i class="fa fa-2x fa-heart-o"&ndash;&gt;-->
                                        <!--&lt;!&ndash;v-bind:class="{'activeIcons': getVideoStatus(reccentVideo)}" aria-hidden="true" @click=""></i>&ndash;&gt;-->
                                        <!--&lt;!&ndash;</p>&ndash;&gt;-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <div class="recently-watched">
            <div class="container">
                <div class="row" v-if="getAuthRecommendedVideos">
                    <div class="col-md-12">
                        <h2>RELATED VIDEOS</h2>
                    </div>
                    <div class="col-md-12">
                        <div class="content">
                            <div class="slider responsive-slick-slider">
                                <div v-for = "reccentVideo in recommendationList">
                                    <div class="slide-player" >
                                        <img class="jw-img" :src="reccentVideo.image" @click="setVideoPlayerObject(reccentVideo.mediaid, reccentVideo.title)" />
                                        <p class="text-wrap-title">
                                            <i class="fa fa-play-circle-o"></i> {{reccentVideo.title}}
                                        </p>
                                        <!--<hr>-->
                                        <!--<p class="right-heart-icon">-->
                                            <!--<i class="fa fa-2x fa-heart-o"-->
                                               <!--v-bind:class="{'activeIcons': getVideoStatus(reccentVideo)}" aria-hidden="true" @click=""></i>-->
                                        <!--</p>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <button @click="redirectToRelatedVideos()" class="btn btn-danger recently-watched-btn btn-transparent btn-lg" :style="styleObject" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)">View All Your Videos</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayListTemp.vue'
    import slick from 'slick-carousel'
    import { mapGetters } from 'vuex'
    import $ from 'jquery'
    import draggable from 'vuedraggable'
    export default {
        name: 'player',
        components: {
            jwplayer,
            draggable,
            'jwplaylist': JwPlayList
        },
        metaInfo () {
            let self = this
            return {
                title: 'TONE Playlist | ' + self.currentVideo.title,
                meta: [
                    {property: 'og:image', content: self.currentVideo.img},
                    {property: 'og:title', content: self.currentVideo.title + ' | TONE Networks'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: self.currentVideo.Description
                    },
                    {property: 'twitter:title', content: self.currentVideo.title + ' | TONE Networks'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.currentVideo.img},
                    {
                        property: 'twitter:description',
                        content: self.currentVideo.Description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                hoverState: false,
                hoverStateTranscript: false,
                activeTab: 0,
                currentVideo: '',
                currentStatus: '',
                currentVideoCode: this.$route.params.videoCode,
                recommendationList: '',
                videoCompleted: false,
                videoSqueeze: false,
                hideLeftVideoIcons: false,
                addRightHoverWidthClass: false,
                addIconHoverWidthClass: false,
                showRateHoverBox: false,
                showShareHoverBox: false,
                showEnjoyHoverBox: false,
                addRightHoverEnjoyClass: false,
                addEnjoyHoverClass: false,
                captionTrack: '',
                viewTranscript: false,
                ratingOne: false,
                ratingTwo: false,
                ratingThree: false,
                ratingFour: false,
                hideAll: false,
                videoMessage: '',
                videoMessageIndex: Math.floor(Math.random() * 7),
                videoGif: '',
                videoGifIndex: Math.floor(Math.random() * 4),
                videoURL: window.location.href,
                playlistVideos: null,
                videoIndex: 0,
                showPlaylist: false,
                newPlaylistName: '',
                videoAdded: false,
                videoRemoved: false,
                selectedVideo: 0,
                selecedPlaylist: 0,
                isMobileOrDesktop: false,
                showMenuOptions: false,
                dragFlagDisabled: true,
                playlistVideoCode: '',
                playlistId: 0,
                videoLogged: false
            }
        },
        beforeDestroy () {
            let self = this
            if (!self.videoLogged) {
                let watchedDuration = self.getCurrentVideoDurationWatched.duration
                if (watchedDuration >= self.getCurrentVideo[0].duration) {
                    self.updateUserPlaylistVideoView(true)
                } else {
                    self.updateUserPlaylistVideoView(false)
                }
            }
        },
        methods: {
            videoChangedInPlaylist () {
                console.log('1. -------------------------> videoChangedInPlaylist():')
                // THIS METHOD IS COPIED FROM ArchivePlaylistPlayer.vue ON 08/19/2021
            },
            playlistCompleted () {
                // https://developer.jwplayer.com/jwplayer/docs/jw8-javascript-api-reference
                // https://developer.jwplayer.com/jwplayer/docs/jw8-javascript-api-reference#jwplayeronuserinactive
                // jwplayer().getPlaylistIndex()
                //   window.jwplayer().playlistItem(videoIndex)

                // if (index >= 0 && index < this.playlistVideos.length) {

                // jwplayer().getPlaylistItem(index)
                // jwplayer().getPlaylist()
                // jwplayer().playlistItem(index)
                // jwplayer().on('playlistComplete') ------------> Fired when the player is done playing all items in the playlist. If the repeat option is set true, this will not be triggered.

                /*
                    jwplayer().on('ready', function(event){
                        relatedPlugin = jwplayer().getPlugin('related');
                    });
                */

                /*
                     let self = this
                    let videoIndex = self.getArchivePlaylistObject.indexOf(videoObjectToPlay)
                    console.log('playVideoInPlylist : videoObjectToPlay = ', videoObjectToPlay)
                    console.log('playVideoInPlylist : actual video index = ', videoIndex)
                    if (videoIndex > -1) {
                        self.videoIndex = videoIndex + 1
                        console.log('playVideoInPlylist : video index of next video = ', videoIndex + 1)
                        self.currentVideo = videoObjectToPlay
                        window.jwplayer().playlistItem(videoIndex)
                    }
                 */

                /*
                     let self = this
                    if (self.getItemChangeInPlaylist) {
                        // console.log('item change', self.getItemChangeInPlaylist)
                        self.videoIndex = self.getItemChangeInPlaylist.index + 1
                        self.currentVideo = self.getItemChangeInPlaylist.item
                    }
                 */

                // userPayload.push(`/tonearchive/${this.$route.params.eventId}/play/${self.videoIndex}/${this.titleURL.toLowerCase()}`)

                console.log('2. -------------------------> playlistCompleted():')
                // this.$router.push('/profile/myprogress')
            },
            updateHoverState (isHover) {
                this.hoverState = isHover
            },
            updateHoverStateTranscript (isHover) {
                this.hoverStateTranscript = isHover
            },
            updateUserPlaylistVideoView (isFull) {
                // console.log('is full?', isFull)
                let self = this
                let watchedDuration, watchedPercentage
                if (isFull) {
                    self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, self.getCurrentVideo[0].duration, 'F')
                } else {
                    // console.info('not full section?')
                    if (self.getCurrentVideoDurationWatched) {
                        watchedDuration = self.getCurrentVideoDurationWatched.duration
                    }
                    watchedPercentage = parseInt(watchedDuration / parseInt(self.getCurrentVideo[0].duration) * 100)
                    if (watchedPercentage >= 5) {
                        // console.info('p section', self.playlistVideoCode)
                        self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, watchedDuration, 'P')
                    } else {
                        // console.info('n section', self.playlistVideoCode)
                        self.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, watchedDuration, 'N')
                    }
                }
            },
            logPlaylistVideoStatus (playlistId, videoCode, duration, watched) {
                console.log('video code in logging', videoCode)
                let self = this
                let payload = {
                    videoCode: videoCode,
                    userId: self.user.userId,
                    playlistId: playlistId,
                    playlistType: 2,
                    playlistCode: null,
                    watched: watched,
                    rating: null,
                    liked: null,
                    durationWatched: duration && duration > 0 ? duration : 0,
                    thumbnailURL: null,
                    opinion: null
                }
                self.$store.dispatch('SET_PLAYLIST_VIDEOSTATUS', payload).then(() => {
                })
            },
            filterPlaylistOptions (playlistId) {
                console.log('playlsit id', playlistId)
                let self = this
                if (self.getUserPlaylists) {
                    let filterPlaylist = self.getUserPlaylists.filter(x => {
                        return x.playlistId.toString() !== playlistId.toString()
                    })
                    console.log('playlists', filterPlaylist)
                    if (filterPlaylist && filterPlaylist.length > 0) {
                        console.info('yes')
                        return true
                    } else {
                        console.info('no')
                        return false
                    }
                } else {
                    return false
                }
            },
            callDelete (video) {
                let self = this
                self.selectedVideo = video.videoCode
                self.selectedPlaylist = self.$route.params.playlistId.toString()
                if (video.videoCode === self.$route.params.videoCode) { // Need to remove video, reload the next video
                    let payload = {}
                    payload.videoCode = video.videoCode
                    payload.userPlaylistId = self.$route.params.playlistId.toString()
                    payload.userId = this.user.userId
                    this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                        $('#' + video.videoCode + ' + ul').toggleClass('hide')
                        if (self.getUserPlaylists) {
                            let findPlaylist = self.getUserPlaylists.filter(x => {
                                return x.playlistId.toString() === self.$route.params.playlistId.toString()
                            })
                            if (findPlaylist && findPlaylist.length > 0) {
                                if (findPlaylist[0].userPlaylistVideos) {
                                    self.playlistVideos = findPlaylist[0]
                                    if (findPlaylist[0].userPlaylistVideos) {
                                        let userPlaylistVideos = findPlaylist[0].userPlaylistVideos
                                        let findNextVideo = userPlaylistVideos.filter(x => {
                                            return x.videoCode !== self.$route.params.videoCode
                                        })
                                        if (findNextVideo && findNextVideo.length > 0) { // Playlist has videos
                                            self.playVideo(self.$route.params.playlistId.toString(), findNextVideo[0].videoCode)
//                                                self.$router.push(`/playlist/${self.$route.params.videoCode.toString()}/play/${findNextVideo[0].videoCode}`)
//                                                location.reload()
                                        } else { // No Video found next in queue
                                            self.$router.push('/')
                                        }
                                    } else {
                                        self.$router.push('/')
                                    }
                                    // self.videoIndex = this.getVideoIndex(findPlaylist[0].userPlaylistVideos, self.$route.params.videoCode)
                                } else {
                                    self.$router.push('/')
                                }
                            } else {
                                self.$router.push('/')
                            }
                        } else {
                            self.$router.push('/')
                        }
                    })
                } else { // just remove video fromt the list
                    let payload = {}
                    payload.videoCode = video.videoCode
                    payload.userPlaylistId = self.$route.params.playlistId.toString()
                    payload.userId = this.user.userId
                    this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                        $('#' + video.videoCode + ' + ul').toggleClass('hide')
                        if (self.getUserPlaylists) {
                            let findPlaylist = self.getUserPlaylists.filter(x => {
                                return x.playlistId.toString() === self.$route.params.playlistId.toString()
                            })
                            if (findPlaylist && findPlaylist.length > 0) {
                                if (findPlaylist[0].userPlaylistVideos) {
                                    let findVideo = findPlaylist[0].userPlaylistVideos.filter(x => {
                                        return x.videoCode.toString() === self.$route.params.videoCode.toString()
                                    })
                                    if (findVideo && findVideo.length > 0) {
                                        self.playlistVideos = findPlaylist[0]
                                        self.videoIndex = this.getVideoIndex(findPlaylist[0].userPlaylistVideos, self.$route.params.videoCode)
                                    }
                                } else {
                                    self.$router.push('/')
                                }
                            } else {
                                self.$router.push('/')
                            }
                        } else {
                            self.$router.push('/')
                        }
                    })
                }
            },
            listUpdated (event) {
//                let self = this
//                let newIndex = this.getVideoIndex(this.playlistVideos.userPlaylistVideos, self.$route.params.videoCode)
//                self.videoIndex = newIndex
//                let data = self.playlistVideos.userPlaylistVideos
//                let videoCodeList = data.map((obj) => {
//                    return obj.videoCode
//                })
//                let playlistLoad = {}
//                playlistLoad.userPlaylistId = self.$route.params.playlistId.toString()
//                playlistLoad.dispOrderVideoCodes = videoCodeList
//                playlistLoad.userId = self.user.userId
//                self.$store.dispatch('SORTPLAYLISTVIDEOS', {playlist: playlistLoad}).then(() => {
//                })
            },
            getVideoIndex (videoArray, videoCode) {
                var index
                for (var i = 0; i < videoArray.length; ++i) {
                    if (videoArray[i].videoCode === videoCode) {
                        index = i
                        break
                    }
                }
                return index + 1
            },
            toggleViewTranscript () {
                this.viewTranscript = !this.viewTranscript
            },
            redirectToRelatedVideos () {
                this.$router.push(`/relatedvideos`)
            },
            getNextVideo (index) {
                if (index >= 0 && index < this.playlistVideos.userPlaylistVideos.length - 1) {
                    return this.playlistVideos.userPlaylistVideos[index + 1]
                } else {
                    return null
                }
            },
            playVideo (playlistId, videoCode, playlistTitle) {
                if (self.getItemChangeInPlaylist) {
                    // console.log('item change', self.getItemChangeInPlaylist)
                    self.videoIndex = self.getItemChangeInPlaylist.index + 1
                    self.currentVideo = self.getItemChangeInPlaylist.item
                }
                console.log('playVideo : playlistId = ', playlistId)
                console.log('playVideo : videoCode = ', videoCode)
                console.log('playVideo : playlistTitle = ', playlistTitle)
                var tempURL = `/playlist/trending/${playlistId}/play/${videoCode}/${playlistTitle.replace(/[^a-zA-Z0-9]/g, '-')}`
                console.log('NEXT URL (tempURL = ) = ', tempURL)
                this.updateUserPlaylistVideoView(false)
                // this.$router.push(`/playlist/trending/${playlistId}/play/${videoCode}/${playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
                this.$router.push(`/playlist/trending/${playlistId}/play/${videoCode}/${playlistTitle.replace(/[^a-zA-Z0-9]/g, '-')}`)
                setTimeout(() => {
                    location.reload()
                }, 500)
            },
            // onVideoComplete () {
            //     let self = this
            //     self.updateUserPlaylistVideoView(true)
            //     self.videoLogged = true
            //     let nextVideoReference = this.getNextVideo(this.videoIndex - 1)
            //     // console.log('next video ref', nextVideoReference)
            //     if (nextVideoReference) {
            //         // console.log('next url', `/playlist/trending/${self.playlistId}/play/${nextVideoReference.videoCode}/${self.playlistVideos.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
            //         this.$router.push(`/playlist/trending/${self.playlistId}/play/${nextVideoReference.videoCode}/${self.playlistVideos.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
            //         setTimeout(() => {
            //             location.reload()
            //         }, 500)
            //     } else {
            //         this.$router.push('/profile/myprogress')
            //     }
            //   //  this.$router.push(`/playlist/${this.$route.params.playlistId}`)
            //  // Method to redirect to next video
            // },

            setUserLike () {
                // Set Video Duration Details
                let watchedDuration, watchedPercentage
                if (this.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt((watchedDuration / this.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'P'
                } else {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'N'
                }
                // Set User Like/Dislike
                if (this.currentStatus.liked === '1') {
                    this.currentStatus.liked = '0'
                } else {
                    this.currentStatus.liked = '1'
                }
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            setOpinion (desc) {
                // Set Video Duration Details
                let watchedDuration, watchedPercentage
                if (this.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'P'
                } else {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'N'
                }
                // Set Opinion
                let opinion = '0'
                if (desc === 'travel') {
                    opinion = '1'
                } else if (desc === 'dating') {
                    opinion = '2'
                } else if (desc === 'news') {
                    opinion = '3'
                } else if (desc === 'recipes') {
                    opinion = '4'
                } else {
                    opinion = '0'
                }
                // Uncheck selected optionss
                if (this.currentStatus.opinion === opinion) {
                    this.currentStatus.opinion = '0'
                } else {
                    this.currentStatus.opinion = opinion
                }
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            setRating (rating) {
                // Set Video Duration Details
                let watchedDuration, watchedPercentage
                if (this.getCurrentVideoDurationWatched) {
                    watchedDuration = this.getCurrentVideoDurationWatched.duration
                }
                watchedPercentage = parseInt(watchedDuration / parseInt(this.getCurrentVideo[0].duration) * 100)
                if (watchedPercentage >= 5) {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'P'
                } else {
                    this.currentStatus.durationWatched = watchedPercentage.toString()
                    this.currentStatus.watched = 'N'
                }
                // Uncheck selected rating
                if (this.currentStatus.rating === rating) {
                    this.currentStatus.rating = '0'
                } else {
                    this.currentStatus.rating = rating
                }
               // this.currentStatus.rating = rating
                this.currentStatus.userId = this.user.userId
                this.$store.dispatch('SETVIDEOSTATUS', this.currentStatus).then(() => {
                    this.currentStatus = this.getCurrentStatus
                })
            },
            logVideoEntry () {
                let logWatchedEntry = {
                    videoCode: this.$route.params.videoCode,
                    userId: this.user.userId,
                    playlistId: null,
                    playlistCode: null,
                    watched: 'N',
                    rating: null,
                    liked: '0',
                    durationWatched: 0,
                    thumbnailURL: null,
                    opinion: null
                }
                this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                })
            },
            setVideoPlayerObject (videoCode, videoTitle) {
                this.$router.push(`/watch/${videoCode}/${videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
                location.reload()
            },
            applyRatingClass (rating) {
                if (rating === this.currentStatus.rating) {
                    return true
                } else {
                    return false
                }
            },
            setCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.each(function () {
                    // var length = $(this).children().length <= 5
                    $slick.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            },
            toggleVideoCompleted () {
                var self = this
                self.videoCompleted = true
                setTimeout(function () {
                    self.videoSqueeze = true
                }, 200)
            },
            replayVideo () {
//                let self = this
                let videoCode = this.$route.params.videoCode
                let videoTitle = this.$route.params.videoTitle
                this.videoCompleted = false
                this.videoSqueeze = false
                this.$router.push(`/watch/${videoCode}/${videoTitle}`)
                this.setVideoPlayerObject(videoCode, videoTitle)
//                this.created.apply(this)
            },
            changeHeight () {
//                $('.left-video-icons').hide()
//                $('.rate-hover-box').show()
//                $('.right-video-icons').addClass('right-hover-width')
//                $('.icons-hover').addClass('icon-hover-width')
                this.hideLeftVideoIcons = true
                this.showRateHoverBox = true
                this.addRightHoverWidthClass = true
                this.addIconHoverWidthClass = true
                this.showShareHoverBox = false
                this.showEnjoyHoverBox = false
            },
            showSharing () {
//                $('.left-video-icons').hide()
//                $('.share-hover-box').show()
//                $('.right-video-icons').addClass('right-hover-width')
//                $('.icons-hover').addClass('icon-hover-width')
                this.hideLeftVideoIcons = true
                this.showShareHoverBox = true
                this.addRightHoverWidthClass = true
                this.addIconHoverWidthClass = true
                this.showRateHoverBox = false
                this.showEnjoyHoverBox = false
            },
            redirectToHome () {
                this.$router.push('/')
            },
            showEnjoy () {
//                $('.enjoy-hover-box').show()
//                $('.left-video-icons').hide()
//                $('.right-video-icons').addClass('right-hover-enjoy')
//                $('.icons-hover').addClass('icon-hover-width')
//                $('div.reset-video-width').addClass('enjoy-hover')
                this.showEnjoyHoverBox = true
                this.hideLeftVideoIcons = true
                this.addRightHoverEnjoyClass = true
                this.addIconHoverWidthClass = true
                this.addEnjoyHoverClass = true
                this.showRateHoverBox = false
                this.showShareHoverBox = false
            },
            resetClass (bool) {
                if (bool) {
                    this.hideLeftVideoIcons = false
                    this.addRightHoverWidthClass = false
                    this.addRightHoverEnjoyClass = false
                    this.addIconHoverWidthClass = false
                    this.showRateHoverBox = false
                    this.showShareHoverBox = false
                    this.showEnjoyHoverBox = false
                    this.addEnjoyHoverClass = false
                } else {
                }
            },
            getVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0 && exists[0].liked === '1') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            setPlaylistVideoStatus (video, playlist, currentStatus) {
                let self = this
                self.selectedVideo = video.videoCode
                self.selectedPlaylist = playlist.playlistId
                if (currentStatus) { // Video is unSelected
                    let payload = {}
                    payload.videoCode = video.videoCode
                    payload.userPlaylistId = playlist.playlistId
                    payload.userId = this.user.userId
                    this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                        self.videoAdded = false
                        self.videoRemoved = true
                    })
                } else { // Video is Selected
                    let payload = {}
                    payload.videoCode = video.videoCode
                    payload.userId = this.user.userId
                    payload.userPlaylistId = playlist.playlistId
                    this.$store.dispatch('ADDVIDEOINPLAYLIST', {playlist: payload}).then(() => {
                        // this.charities = this.getAuthUserVideos
                        self.videoAdded = true
                        self.videoRemoved = false
                    })
                }
                setTimeout(() => {
                    self.videoAdded = false
                    self.videoRemoved = false
                }, 1500)
            },
            verifyPlaylistExists () {
                if (this.getUserPlaylists) {
                    let playlistsWithVideo = this.getUserPlaylists.filter(x => {
                        return x.userPlaylistVideos !== null
                    })
                    if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            verifyVideoExists (playlist, video) {
                let self = this
                if (this.getUserPlaylists) {
                    let findPlaylist = this.getUserPlaylists.filter(x => {
                        return x.playlistId === playlist.playlistId
                    })
                    if (findPlaylist && findPlaylist.length > 0) {
                        if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                            let videos = findPlaylist[0].userPlaylistVideos.filter(x => {
                                return x.videoCode === video.videoCode
                            })
                            if (videos && videos.length > 0) {
                                self.playlistHasVideo = true
                                return true
                            } else {
                                return false
                            }
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            addNewPlayList () {
                if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                    let payload = {}
                    payload.userId = this.user.userId
                    payload.title = this.newPlaylistName
                    this.$store.dispatch('CREATEPLAYLIST', {playlist: payload}).then(() => {
                        this.newPlaylistName = ''
                        // this.charities = this.getAuthUserVideos
                    })
                }
            },
            showPlaylistMenu (videoCode) {
                // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            hidePlaylistMenu (videoCode) {
                // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            playVideoInPlylist (videoObjectToPlay) {
                let self = this
                let videoIndex = self.getTrendingNewPlaylistObject.indexOf(videoObjectToPlay)
                console.log('playVideoInPlylist : actual video index', videoIndex)
                if (videoIndex > -1) {
                    self.videoIndex = videoIndex + 1
                    console.log('playVideoInPlylist : video index of next video', videoIndex + 1)
                    self.currentVideo = videoObjectToPlay
                    window.jwplayer().playlistItem(videoIndex)
                }
                // this.$router.push(`/tonearchive/${this.$route.params.eventId}/play/${videoSequence}/${this.titleURL.toLowerCase()}`)
                // location.reload()
            }
            // onVideoComplete () {
            //     let nextVideoReference = this.getNextVideo(this.videoIndex)
            //     if (nextVideoReference) {
            //         this.$router.push(`/tonearchive/${this.$route.params.eventId}/play/${nextVideoReference}/${this.titleURL.toLowerCase()}`)
            //         location.reload()
            //     }
            //     //  this.$router.push(`/playlist/${this.$route.params.playlistId}`)
            //     // Method to redirect to next video
            // }
        },
        watch: {

//            '$(window).width()' (to, from) {
//                console.log('width of screen', $(window).width())
//                if ($(window).width() > 739) {
//                    this.showPlaylist = false
//                } else {
//                    this.showPlaylist = true
//                }
//            },
            'getItemChangeInPlaylist' (to, from) {
                let self = this
                console.log('1 ------------> getItemChangeInPlaylist')
                if (self.getItemChangeInPlaylist) {
                    console.log('2 ------------> getItemChangeInPlaylist')
                    // console.log('item change', self.getItemChangeInPlaylist)
                    self.videoIndex = self.getItemChangeInPlaylist.index + 1
                    self.currentVideo = self.getItemChangeInPlaylist.item
                }
                // this.$router.push(`/tonearchive/${this.$route.params.eventId}/play/${self.videoIndex}/${this.titleURL.toLowerCase()}`)
                // Log user activity
                let userPayload = []
                let uId = 0
                if (self.user) {
                    uId = self.user.userId
                }
                userPayload.push(uId)
                // userPayload.push(`/playlist/${this.$route.params.eventId}/play/${self.videoIndex}/${this.titleURL.toLowerCase()}`)
                console.log('3 ------------> getItemChangeInPlaylist : user activity', userPayload)
                this.$store.dispatch('LOGUSERACTIVITY', userPayload)

                console.log('getItemChangeInPlaylist : self.playlistId = ', self.playlistId)
                console.log('getItemChangeInPlaylist : self.currentVideo.videoCode = ', self.currentVideo.videoCode)
                console.log('getItemChangeInPlaylist : self.currentVideo.title = ', self.currentVideo.title)
                console.log('getItemChangeInPlaylist : self.currentVideo = ', self.currentVideo)
                console.log('getItemChangeInPlaylist : self.expertId = ', self.currentVideo.expertid)

                self.$store.dispatch('GETEXPERT', self.currentVideo.expertid).then(() => {
                    // console.log('A.  videoChangedInPlaylist : self.currentVideo = ', self.currentVideo)
                })
                // this.playVideo(self.playlistId, self.playlistVideoCodself.videoCode, self.title)
                // this.playVideo(self.playlistId, self.currentVideo.videoCode, self.currentVideo.title)
            }
        },
        mounted: function () {
            let self = this
            console.info('inside trending player')
            if (self.user) {
                if (self.getTrialDays < 0) {
                    self.$router.push('/becomemember')
                }
                // Log User activity
                let userPayload = []
                let uId = 0
                if (self.user) {
                    uId = self.user.userId
                }
                userPayload.push(uId)
                userPayload.push(self.$route.fullPath)
                console.log('user activity', userPayload)
                this.$store.dispatch('LOGUSERACTIVITY', userPayload)
                if ($(window).width() > 739) {
                    self.showPlaylist = true
                } else {
                    self.showPlaylist = false
                }
                self.playlistVideoCode = this.$route.params.videoCode
                self.playlistId = this.$route.params.playlistId
                this.logPlaylistVideoStatus(self.playlistId, self.playlistVideoCode, 0, 'N')
                if (this.$route.params.playlistId && this.$route.params.videoCode) {
                    self.$store.dispatch('GET_TRENDING_PLAYLISTS').then(() => {
                        if (self.getUserPlaylists) {
                            console.info(1)
                            let findPlaylist = self.getUserPlaylists.filter(x => {
                                return x.playlistId.toString() === self.$route.params.playlistId.toString()
                            })
                            if (findPlaylist && findPlaylist.length > 0) {
                                if (findPlaylist[0].userPlaylistVideos) {
                                    let findVideo = findPlaylist[0].userPlaylistVideos.filter(x => {
                                        return x.videoCode.toString() === self.$route.params.videoCode.toString()
                                    })
                                    console.info(2)
                                    if (findVideo && findVideo.length > 0) {
                                        self.playlistVideos = findPlaylist[0]
                                        self.videoIndex = this.getVideoIndex(findPlaylist[0].userPlaylistVideos, self.$route.params.videoCode)
//                                    self.videoIndex = findPlaylist[0].userPlaylistVideos.findIndex(x => x.videoCode === self.$route.params.videoCode)
                                        // Retreive Video Object
                                        self.$store.dispatch('GETCURRENTVIDEO', self.$route.params.videoCode).then(() => {
                                            let video = this.getCurrentVideo
                                            self.currentVideo = {
                                                video: video[0].sources[video[0].sources.length - 1].file,
                                                title: video[0].title,
                                                img: video[0].image,
                                                playerID: new Date(),
                                                tracks: video[0].tracks,
                                                Description: video[0].description,
                                                mediaId: video[0].mediaid,
                                                expertId: video[0].expertId
                                            }
                                            self.$store.dispatch('GETEXPERT', video[0].expertid).then(() => {
                                            })
                                        })
                                        // Get Video Transcript
                                        self.$store.dispatch('GETVIDEOTRANSCRIPT', self.$route.params.videoCode).then(() => {
                                        })
                                        // Get Recommended Videos
                                        self.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', self.user.userId).then(() => {
                                            let filteredList = this.getAuthRecommendedVideos.filter(code => {
                                                return code.mediaid !== this.currentVideoCode
                                            })
                                            this.recommendationList = filteredList
                                            setTimeout(() => {
                                                this.setCarousal()
                                            }, 2000)
                                            // this.recommendedVideos = this.getAuthRecommendedVideos
                                        })
                                        self.$store.dispatch('LOAD_NEW_PLAYER_TRENDING_PLAYLISTS', self.$route.params.playlistId).then(() => {
                                            if (self.getTrendingNewPlaylistObject) {
                                                console.log('playlist object found : getTrendingNewPlaylistObject = ', self.getTrendingNewPlaylistObject)
                                                self.currentVideoCode = self.getTrendingNewPlaylistObject[0]
                                            }
                                        })
                                    } else {
                                        self.$router.push('/mytone')
                                    }
                                } else {
                                    self.$router.push('/mytone')
                                }
                            } else {
                                self.$router.push('/mytone')
                            }
                        } else {
                            self.$router.push('/mytone')
                        }
                    })
                } else {
                    self.$router.push('/mytone')
                }
            } else {
                self.$router.push('/')
            }
           // this.videoGif = this.getVideEndGif[this.videoGifIndex]
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'user', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert',
                'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getUserPlaylists', 'getTrialDays', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getTrendingNewPlaylistObject', 'getItemChangeInPlaylist']
            ),
            styleObject () {
                if (this.hoverState) {
                    return {
                        color: '#FFFFFF',
                        backgroundColor: this.getCorpButtonColor,
                        borderColor: this.getCorpButtonColor
                    }
                } else {
                    return {
                        // border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor,
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: this.getCorpButtonColor
                        // borderColor: this.getCorpButtonColor
                    }
                }
            },
            styleObjectTranscript () {
                if (this.hoverStateTranscript && this.viewTranscript) {
                    return {
                        color: '#FFFFFF',
                        backgroundColor: this.getCorpButtonColor + ' !important',
                        borderColor: this.getCorpButtonColor + ' !important'
                    }
                } else {
                    return {
                        border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor
                    }
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .video-player-wrapper .watch-again .current-video-img img {
        object-fit: cover;
    }
    .video-player .right-video-icons .enjoy-hover-box {
        width: 20%;
        height: 100%;
        background: #f0617d;
        position: absolute;
        top: 0;
        right: 0;
        padding: 15% 0px 0;
        text-align: left;
    }
    .video-player .right-video-icons .enjoy-hover-box button.btn {
        margin: 0 0 10px;
        border-color: white;
        border-radius: 3px;
        padding: 12px 0 13px;
        display: block;
        width: 80%;
        margin: 0px auto 10px;
        color: #fff;
    }
    .video-player-wrapper .tooltipBox {
        width: 100%;
        text-align: center;
        padding-bottom: 10px;
        height: 35px;
        margin-top: 24px;
    }
    @media (min-width:768px) {
        .video-player .right-video-icons .enjoy-hover-box {
            padding: 117px 0px 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating {
            overflow: hidden;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating p {
            color: white;
            display: block;
            font-size: 16px;
            letter-spacing: 0.5px;
            margin-top: 23px;
            margin-bottom: 20px;
            padding: 0 10%;
            text-align: center;
        }
    }
    .video-player .right-video-icons .rate-hover-box span {
        margin-bottom: 20px;
    }
    .video-player .right-video-icons .rate-hover-box button:hover {
        background: #ac2925;
    }
    .video-player .btn-danger:focus {
        background: inherit;
        border-color: inherit;
        outline: none;
    }
    .video-player .right-video-icons div button.btn-danger:hover{
        background:rgba(0,0,0,0.1);
    }
    .video-player .right-video-icons div button.btn-danger.active:hover{
        background:#ac2925;
    }
    .video-player .right-video-icons div button.btn-danger.active:focus{
    color: #fff;
    background-color: #ac2925;
    border-color: #fff;
    }
    .profile-content img {
        object-fit: cover;
        object-position: center center;
    }
    .playlistholderdiv {
        width: 15%;
        color: #fff;
        position: absolute;
        top: 0;
        right: 0;
        padding: 15px;
        bottom: 0;
        overflow-y: auto;
    }

    .playlistholderdiv img {
        max-width: 100%;
        margin: 0 0 10px;
    }

    .fixgraybgpl .video-player-background {
        position: relative;
    }

    .playlistholderdiv h4 {
        font-size: 16px;
    }

    .playlistholderdiv p {
        font-size: 14px !important;
    }
    .playlistentrydiv {
        position: relative;
    }

    .playlistentrydiv.playing:after {
        position: absolute;
        right: 0;
        text-align: center;
        font-weight: 900;
        text-shadow: 0 1px 3px rgba(0,0,0,0.75);
        content: "";
        height: 0;
        width: 0;
        border: 10px solid transparent;
        top: 12px;
        border-left-color: #f0617d;
        -webkit-transform: translateY(-0%);
        transform: translateY(-0%);
        left: 2px;
    }
    .playlistentrydiv.playingMobile:after {
        position: absolute;
        right: 0;
        text-align: center;
        font-weight: 900;
        text-shadow: 0 1px 3px rgba(0,0,0,0.75);
        content: "";
        height: 0;
        width: 0;
        border: 10px solid transparent;
        top: 2px;
        border-left-color: #f0617d;
        -webkit-transform: translateY(-0%);
        transform: translateY(-0%);
        left: 2px;
    }
    @media(max-width:5992px) {
        .playlistholderdiv {
            width: 100%;
            position: static;
            overflow: visible;
        }
        .playlistholderdiv img {
            width: 100px;
            float: left;
            margin: 0px 15px 10px 0;
        }

        .playlistentrydiv {
            overflow: hidden;
            text-align: left;
            border-bottom: 1px solid #666;
            margin: 0 0 0px;
        }
        .playlistentrydiv {
            transition: all 0.5s ease;
            cursor: pointer;
        }

        .playlistentrydiv:hover {
            background: #fff;
        }

        .playlistentrydiv:hover > p {
            transition: all 0.5s ease;
            color: #000;
        }
        div:last-of-type > .playlistentrydiv {
            margin: 0;
            border-bottom: 0 none transparent;
        }

        div:last-of-type > .playlistentrydiv img {
            margin-bottom: 0;
        }

    }
    .btn-group.plusicon {
        position: absolute;
        right: 50px;
        bottom: 0px;
        height: 29px;
    }
    li.divider {
        border-bottom: 1px solid #ddd;
        margin: 5px -15px;
    }

    button.dropdown-toggle.ellipsis.pull-right {
        background: transparent;
        border: 0 none transparent;
        padding: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right{
        font-size: 21px;
        top: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right li label{
        padding: 30px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+ ul li a {
        padding: 3px 15px;
        margin-bottom: 5px;
        display: block;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control {
        height: 30px;
        padding: 5px 30px 5px 5px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle {
        position: absolute;
        top: 6px;
        font-size:24px;
        right:20px;
        cursor: pointer;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+div + ul li label{
        position:relative;
    }
    button.dropdown-toggle.ellipsis.pull-right+ div + ul,
    button.dropdown-toggle.ellipsis.pull-right+ ul{
        left: 0;
        right: auto;
        width: 230px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 5px;
        top: 100%;
        position: absolute;
        z-index: 5000;
        list-style: none;
        text-align: left;
        padding: 15px;
    }
    .backdropformenu{
        position:fixed;
        z-index:4900;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: transparent;
    }
    .profile .tabContent .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        left: auto ;
        right: 0;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    label.notificationwithcheckboxes span{
        font-size: 10px;
    }

    span.removed {
        color: red;
    }
    span.added {
        color: #4caa98;
    }

    label.notificationwithcheckboxes {
        position: relative;
        display:block;
    }
   /*Copied for Playlist Options*/
    .btn-group.plusicon {
        position: absolute;
        right: 50px;
        bottom: 0px;
        height: 29px;
    }
    li.divider {
        border-bottom: 1px solid #ddd;
        margin: 5px -15px;
    }

    button.dropdown-toggle.ellipsis.pull-right {
        background: transparent;
        border: 0 none transparent;
        padding: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right{
        font-size: 21px;
        top: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right li label{
        padding: 30px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+ ul li a {
        padding: 3px 15px;
        margin-bottom: 5px;
        display: block;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control {
        height: 30px;
        padding: 5px 30px 5px 5px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle {
        position: absolute;
        top: 6px;
        font-size:24px;
        right:20px;
        cursor: pointer;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+div + ul li label{
        position:relative;
    }
    button.dropdown-toggle.ellipsis.pull-right+ div + ul,
    button.dropdown-toggle.ellipsis.pull-right+ ul{
        left: 0;
        right: auto;
        width: 230px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 5px;
        top: 100%;
        position: absolute;
        z-index: 5000;
        list-style: none;
        text-align: left;
        padding: 15px;
    }
    .backdropformenu{
        position:fixed;
        z-index:4900;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: transparent;
    }
    .profile .tabContent .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        left: auto ;
        right: 0;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    label.notificationwithcheckboxes span{
        font-size: 10px;
    }

    span.removed {
        color: red;
    }
    span.added {
        color: #4caa98;
    }

    label.notificationwithcheckboxes {
        position: relative;
        display:block;
    }
    .playlistholderdiv button.dropdown-toggle.ellipsis.pull-right {
        display: block;
        top: 0px;
        font-size: 0;
        line-height: 1;
        color: #f0617d;
        height: 10px;
        width: 30px;
        right: 0;
    }

    .playlistholderdiv .plusicon.btn-group {
        top: 0;
        right: 0;
        width: 100%;
        max-width:350px

    }

    .playlistholderdiv button.dropdown-toggle.ellipsis.pull-right:before {
        content: "...";
        position: absolute;
        top: -10px;
        line-height: 0;
        font-size: 50px;
        display: block;
        right: 5px;
        letter-spacing: -2px;
    }

    .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        padding: 5px;
        top: 11px;
        width: 100%;
        border-radius:0;
        border:0 none transparent;
    }

    .playlistholderdiv li.divider {
        margin: 2px 0 4px;
    }

    .playlistholderdiv button.dropdown-toggle.ellipsis.pull-right+ ul li label {
        padding: 0 !important;
        margin: 0;
        font-size: 10px;
    }

    .playlistholderdiv input[type="checkbox"] {position: relative;top: 3px;}

    .playlistentrydiv {
        overflow:visible !important;
        clear:both;
        display:table;
        width:100%;
        padding-top:10px;
    }
    .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        color: #000;
    }
    .playlistholderdiv>div>span>div:last-of-type .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        top: auto;
        bottom: 20px;
    }
    .playlistholderdiv>div>span>div:last-of-type .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        top: 11px;
        bottom: auto;
    }
    .playlistentrydiv {
        padding-right: 30px;
    }
</style>

<style>
    .list-complete-item {
        padding: 4px;
        margin-top: 4px;
        border: solid 1px;
        transition: all 1s;
    }

    .list-complete-enter, .list-complete-leave-active {
        opacity: 0;
    }
    body{
        -ms-overflow-style:scrollbar;
    }
    .fixgraybgpl .video-player .left-video-icons{background:transparent;}
    @media(max-width:992px) {
        .side-content pre {
            overflow: scroll;
            white-space: pre-wrap;
        }
        .fixgraybgpl .video-player .jwplayer.jw-flag-aspect-mode {
            height: auto !important;
        }
    }
    /*@media (max-width: 991px) and (min-width: 320px){
        .fixgraybgpl .video-player .reset-video-width {
            max-width:85%;
        }
    }*/
</style>



// WEBPACK FOOTER //
// TrendingPlaylist.vue?2f5fd7ed